



















































import Vue from 'vue'
declare var $: any
import { mapState } from 'vuex';
import { ManualCallStatusState } from '../../store/state_models';
import { EventBus } from '../../models/event-bus';

export default Vue.extend({
  data() {
    return {
      firstClick: true
    }
  },
  methods: {
    selected(type: string) {
      if (this.firstClick) {
        this.firstClick = false
      }
      var _self = this;
      EventBus.$emit('callNextManual', this.manualCallId, type);
      EventBus.$emit('dialer:callNextManual', type);
      this.$store.commit('manualCallStatus/hide');
    }
  },
  computed: {
    ...mapState('manualCallStatus', {
        manualCallId: (s: ManualCallStatusState) => {
            return s.manualCallId;
        },
    })
  },
  watch: {
    'manualCallId': function(manualCallId: string) {
            var _self = this;
            console.log(manualCallId);
            if (manualCallId) {
              $(_self.$refs.modal)
                .modal('show')
            } else {
              $(_self.$refs.modal).modal('hide');
            }
        }
  },
  mounted() {
    $(this.$refs.modal).modal({
      backdrop: 'static',
      keyboard: false,
      show: false
    })
  }
})
